@let emailControl = profileForm.controls.email;
<div class="text-nowrap d-flex align-items-center m-0 py-2">
  <label class="w-50 me-2 m-0 mb-2 mb-sm-0 color-gray-500">
    {{ 'SETTINGS.BASICS.EMAIL' | translate }}: *
  </label>

  <input
    class="w-50 ms-2 form-control"
    [class.is-invalid]="emailControl.touched && emailControl.invalid"
    [formControl]="emailControl"
    [title]="'SETTINGS.BASICS.EMAIL' | translate"
    id="email"
    autocomplete="email"
  />
</div>

@if (emailControl.touched && emailControl.invalid) {
  <div class="text-danger small px-0 col-4 text-pre-wrap offset-6">
    <span class="ps-2">{{ emailControl.errors | translateValidationErrors: '.\n' }}</span>
  </div>
}

@let firstNameControl = profileForm.controls.firstName;
<div class="text-nowrap d-flex align-items-center m-0 py-2">
  <label class="w-50 me-2 m-0 mb-2 mb-sm-0 color-gray-500">
    {{ 'SETTINGS.PROFILE.FIRST_NAME'| translate }}:
  </label>

  <input
    class="w-50 ms-2 form-control"
    [class.is-invalid]="firstNameControl.touched && firstNameControl.invalid"
    [formControl]="firstNameControl"
    [title]="'SETTINGS.PROFILE.FIRST_NAME'| translate"
  />
</div>

@if (firstNameControl.touched && firstNameControl.invalid) {
  <div class="text-danger small px-0 col-4 text-pre-wrap offset-6">
    <span class="ps-2">{{ firstNameControl.errors | translateValidationErrors: '.\n' }}</span>
  </div>
}

@let lastNameControl = profileForm.controls.lastName;
<div class="text-nowrap d-flex align-items-center m-0 py-2">
  <label class="w-50 me-2 m-0 mb-2 mb-sm-0 color-gray-500">
    {{ 'SETTINGS.PROFILE.LAST_NAME'| translate }}:
  </label>

  <input
    class="w-50 ms-2 form-control"
    [class.is-invalid]="lastNameControl.touched && lastNameControl.invalid"
    [formControl]="lastNameControl"
    [title]="'SETTINGS.PROFILE.LAST_NAME'| translate"
  />
</div>

@if (lastNameControl.touched && lastNameControl.invalid) {
  <div class="text-danger small px-0 col-4 text-pre-wrap offset-6">
    <span class="ps-2">{{ lastNameControl.errors | translateValidationErrors: '.\n' }}</span>
  </div>
}

@let phoneControl = profileForm.controls.phone;
<div class="text-nowrap d-flex align-items-center m-0 py-2">
  <label class="w-50 me-2 m-0 mb-2 mb-sm-0 color-gray-500">
    {{ 'SETTINGS.PROFILE.PHONE'| translate }}:
  </label>

  <input
    class="w-50 ms-2 form-control"
    [class.is-invalid]="phoneControl.touched && phoneControl.invalid"
    [formControl]="phoneControl"
    [title]="'SETTINGS.PROFILE.PHONE'| translate"
    id="phone"
    phoneAsYouType
  />
</div>

@if (phoneControl.touched && phoneControl.invalid) {
  <div class="text-danger small px-0 col-4 text-pre-wrap offset-6">
    <span class="ps-2">{{ phoneControl.errors | translateValidationErrors: '.\n' }}</span>
  </div>
}
